import { render, staticRenderFns } from "./handpickCategoryList.vue?vue&type=template&id=2ebb2f67&scoped=true&"
import script from "./handpickCategoryList.vue?vue&type=script&lang=js&"
export * from "./handpickCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb2f67",
  null
  
)

export default component.exports